import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    maxWidth: '1440px',
    padding: {
      xs: '20px 24px',
      md: '32px 6.5%',
      lg: '48px 6.5%',
    },
    marginX: 'auto',
    gap: '40px',
  },

  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    width: { xs: '100%', md: 'calc(50% - 10px)' },
  },
  mainHeading: {
    color: 'text.primary',
  },
  image: {
    width: '100%',
    height: {
      xs: '300px',
      md: '100%',
    },
    borderRadius: '24px',
    overflow: 'hidden',
    ' img': {
      objectFit: 'inherit !important',
    },
  },
  sectionWrapper: {},
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
